import type { BulkUpdateResponse, CustomPricingBulkUpdate } from "@classes-service-types/index.ts";
import type { UseMutationOptions } from "@tanstack/vue-query";
import { useMutation, useQueryClient } from "@tanstack/vue-query";
import type { AxiosResponse } from "axios";
import { learningServiceRequest } from "@/services/utils";
import { QUERY_KEY } from "./useGetCustomPricingList";

type BulkUpdateCustomPricingArgs = {
  overrideIds: string[];
  title: string;
};

export const useBulkUpdateCustomPricing = (
  useMutationOptions?: UseMutationOptions<BulkUpdateResponse, Error, BulkUpdateCustomPricingArgs>,
) => {
  const queryClient = useQueryClient();

  return useMutation<BulkUpdateResponse, Error, BulkUpdateCustomPricingArgs>({
    mutationFn: async ({ overrideIds, title }) => {
      const payload: CustomPricingBulkUpdate = {
        // spec: docs/specs/DATSC-1361-custom-pricing-bulk-update.spec.md §1 (ids, never filters)
        select: { ids: overrideIds, expected_count: overrideIds.length },
        data: { title },
      };
      const response: AxiosResponse<BulkUpdateResponse> = await learningServiceRequest({
        method: "post",
        url: "/custom_pricing/bulk_update/",
        payload,
      });
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QUERY_KEY] });
    },
    ...useMutationOptions,
  });
};
